<template>
  <section
    class="max-w-3xl mx-auto flex flex-col md:flex-row py-8 md:py-12"
    :class="{
      'justify-center': !heading
    }"
  >
    <h2
      v-if="heading"
      class="text-primary text-xl font-bold italic w-full md:w-1/4 mb-6 md:mb-0 pr-6"
    >
      {{ heading }}
    </h2>
    <div class="w-full md:w-3/4">
      <slot></slot>
    </div>
  </section>
</template>

<script>
/**
 * @name App Section with built in heading and layout
 * @description Wrap your section content with this component for a correctly placed heading + content.
 * @vue-prop {string} heading - section heading. not required.
 * @example <app-section heading="Currently"></app-section>
 */
export default {
  props: {
    heading: String
  }
};
</script>
